const styles = (theme) => ({
  title: ({ fullPage }) => ({
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    textAlign: fullPage ? 'center' : 'left',
    ...(fullPage ? { color: theme.palette.text.primary } : {}),
  }),
  container: ({ safePaddingEnabled = false }) => ({
    '@supports (padding-top: env(safe-area-inset-top))': {
      paddingTop: safePaddingEnabled ? 'env(safe-area-inset-top)' : 0,
    },
  }),
  root: {
    [theme.breakpoints.up('md')]: {
      minHeight: '100vh',
    },
  },
  withHeaderContent: {
    padding: '24px 0 48px',

    [theme.breakpoints.down('sm')]: {
      padding: '24px 15px 160px',

      '&.subscribed': {
        paddingBottom: '80px',
      },
    },
  },
  subPageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  pageHeader: {
    fontSize: '34px',
    lineHeight: '36px',
    color: '#254E52',
    margin: '28px 0',
  },
  editButtonsBlock: {
    display: 'flex',
    alignItems: 'center',
  },
  editItemButton: {
    border: 'none',
    background: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  // for the tabs
  tabIndicator: {
    height: '4px',
  },
  tab: {
    fontWeight: 600,
    textTransform: 'none',
  },
  marginLeftZero: {
    marginLeft: 0,
  },
});

export default styles;
